import { FC, ReactNode } from 'react'
import { Panel, Stack } from 'rsuite'
import dynamic from 'next/dynamic'

import InfoIcon from './Icons/InfoIcon'

import styles from '../styles/CustomNotificationCard.module.less'

const ContactCard = dynamic(() => import('./ContactCard'))

export interface CustomNotificationCardProps {
  title: string
  children?: ReactNode
  shouldDisplayContactCard?: boolean
  testId?: string
}

const CustomNotificationCard: FC<CustomNotificationCardProps> = ({
  children,
  title,
  shouldDisplayContactCard,
  testId,
}) => (
  <Panel
    className={styles.container}
    data-testid={testId}
  >
    <Stack
      alignItems="flex-start"
      spacing={20}
    >
      <InfoIcon />
      <Stack.Item grow={1}>
        <p>
          <b>{title}</b>
        </p>
      </Stack.Item>
    </Stack>
    <p>{children}</p>
    {shouldDisplayContactCard && (
    <ContactCard
      hasContactModalButton
      className="margin-top-spacer-double"
      size="sm"
    />
    )}
  </Panel>
)

export default CustomNotificationCard
